module.exports = __webpack_public_path__ + "img/bg-waves.e35f82f0.svg";